import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';

import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'bookingNote-modal',
    templateUrl: './bookingNote-popup.component.html',
    styleUrls: ['./bookingNote-popup.component.css'],
    providers: [],
    exportAs: 'bookingNotePopup'
})
export class BookingNotePopupComponent implements OnInit {
    @ViewChild('childModal') childModal: ModalDirective;
    @Output() facilityid = new EventEmitter<string>();
    private stringConstants = CONSTANT_MESSAGES;
    private date = '';
    private item = '';
    constructor() {
    }
    private utilityFunctions = new UtilityFunctions();
    ngOnInit() {

    }

    public showChildModal(item, timezoneOffset): void {
        this.item = item ? item : '';
        this.date = moment(item.startTime).utcOffset(timezoneOffset).format('ll');
        this.childModal.config.backdrop = false;
        this.childModal.config.keyboard = false;
        this.utilityFunctions.setBackGroundBlack();
        this.childModal.show();
    }

    public hideChildModal(): void {
        this.utilityFunctions.removeBackGroundBlack();
        this.childModal.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/bookingNote-popup/bookingNote-popup.component.ts